/**
 * @file 相关证明上传
 * @author
 */

import React, {useState} from 'react';

import {
    uploadPngOrJpg,
    getBase64,
    uploadProps
} from './conf';
import DemoImg from './demoImg.tsx';
import LabelFormItem from '../LabelFormItem/index.tsx';

import {PlusOutlined, ExclamationCircleOutlined} from '@ant-design/icons';
import {Upload} from 'antd';

import './index.less';

interface Props {
    title: string;
    maxImgLength: number;
    updateData: any;
    isMsgRequired: boolean;
    type: string;
    data: any;
    tips: string;
    beforeUpload: any;
    onChange?: any;
    demoImgs?: [];
    disabled?: boolean;
}

export default function UploadProof(props: Props) {
    const {
        title,
        maxImgLength,
        updateData,
        onChange,
        data,
        isMsgRequired,
        type,
        disabled,
        tips,
        demoImgs,
        beforeUpload
    } = props;
    const [preview, setPreview] = useState({
        visible: false,
        title: '',
        image: ''
    });
    function getFieldsItem(name: string, length: number) {
        let ele: any = <PlusOutlined />;
        data[type].map((item: any, index: number) => {
            if (index + 1 >= length) {
                ele = null;
            }
        });
        return ele;
    }
    const uploadButton = (
        <div className="upload-proof-btn">
            <PlusOutlined style={{fontSize: '14px'}} />
            <div style={{marginTop: 2, fontSize: '12px'}}>上传图片</div>
        </div>
    );
    function getUploadPlusOutlined(name: string, length: number) {
        return data[type]?.length
            ? getFieldsItem(name, length)
            : uploadButton;
    }
    // 预览功能
    const handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreview({
            visible: true,
            image: file.url || file.preview,
            title: file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
        });
    };
    const handlePreviewCancel = () => {
        setPreview({
            visible: false,
            image: '',
            title: ''
        });
    };
    const handleUploadChange = (
        info:{
            fileList: any[],
            file: {status?: string, response:{code: number, message: string}}
        }
    ) => {
        // 上传格式不符合要求时，无status
        if (!info.file.status) {
            return;
        }

        let fileList = [...info.fileList];
        let imgErr = '';
        fileList = fileList.map(file => {
            const obj:any = {};
            if (file.response && file.response.code === 200) {
                obj.id = file.response?.data?.id;
            } else {
                imgErr = file.response?.message;
            }
            return {
                ...file,
                ...obj
            };
        });
        const tempObj = fileList;
        let updateObj = {[type]: tempObj, [type + 'Err']: imgErr};

        // 企业合法资质匹配企业名称
        if (type === 'companyQualify') {
            info.fileList.forEach(file => {
                if (file.response && file.response.code === 200) {
                    const companyName = file.response?.data?.name;
                    updateObj = {
                        ...updateObj,
                        companyName: companyName
                    };

                    if (companyName.length) {
                        updateObj = {
                            ...updateObj,
                            companyNameErr: ''
                        };
                    }
                }
            });
        }

        updateData && updateData(updateObj);
        onChange && onChange(updateObj);
    };

    const isSpots = ['companyQualify'];
    return <div className="upload-proof">
        <LabelFormItem isMsgRequired={isMsgRequired} title={title} />
        <div className="upload-proof-content">
            <Upload
                {...uploadProps}
                data={{
                    'product_id': 'haoma',
                    'is_spot': isSpots.includes(type) ? 'YES' : 'NO'
                }}
                beforeUpload={beforeUpload ?? uploadPngOrJpg}
                onChange={handleUploadChange}
                onPreview={handlePreview}
                fileList={data[type]}
                disabled={disabled}
            >
                {getUploadPlusOutlined(type, maxImgLength)}
            </Upload>
            {data[type + 'Err'] && <p className="upload-err">
                <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                {data[type + 'Err']}
            </p>}
            <div style={{display: 'flex'}}>
                {demoImgs && demoImgs.map((item, index) =>
                    <DemoImg key={index} img={item} setPreview={setPreview}/>)}
                <div className="cert-other">
                    {tips}
                </div>
            </div>
        </div>
        {preview.visible && <div
            className={'magnify'}
            onClick={handlePreviewCancel}
        >
            <img
                src={preview.image}
                alt=""
                onClick={e => {
                    e.stopPropagation();
                }}
            />
        </div>}
    </div>;
}
